<div class="preview-container" >
    <div class="close-icon" *ngIf="device?.isDesktop">
        <i class="icon-smash_close icon-close-preview" (click)="unscroll()"></i>
    </div>
    <div class="preview-deck-container" [ngClass]="{'desktop': device?.isDesktop, 'mobile': device?.isMobile, 'tablet': device?.isTablet}">
        <app-deck 
            [preview]="preview" 
            [files]="files"
            [selectedFiles]="selectedFiles"
            (videoPlaying)="onVideoPlaying($event)"
            [device]="device">
        </app-deck>
    </div>    
    <div class="footer">
        <a href="{{ hostname }}" class="incentive">
            <i class="icon-smash_logo_chip"></i>
            <div translate [innerHtml]="'VIEWER_FOOTER' | translate | safeHtml"></div>
        </a>
    </div>
    <div class="download-all-mobile-container" *ngIf="device?.isMobile && !hideButton">
        <!-- DOWNLOAD ALL MOBILE -->
        <button class="btn-v3 red download-btn" (click)="downloadZip()"><i class="icon-smash_icologo_chip"></i>{{ 'VIEWER_DOWNLOAD_ALL' | translate }}</button>
    </div>
</div>